import { render, staticRenderFns } from "./SchoolTrackRecordDialog.vue?vue&type=template&id=157dc636&scoped=true&"
import script from "./SchoolTrackRecordDialog.vue?vue&type=script&lang=js&"
export * from "./SchoolTrackRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTrackRecordDialog.vue?vue&type=style&index=0&id=157dc636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157dc636",
  null
  
)

export default component.exports